import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import ConfirmDialog from "@/components/ConfirmDialog";
import NotesList from "@/components/shownotes/NotesList";
import { noteTitle } from "@/components/shownotes/meta";

const COPY = {
  review: ["Nothing to review", "Notes submitted by stage managers and your saved drafts appear here."],
  mine: ["No reports yet", "Use New notes to submit Rehearsal or Show Notes for your director's review."],
};

// Director review queue (drafts / pending / returned) or a stage manager's own submissions.
export default function WorkTab({ mode, userId, onOpen, reload, onChanged, onCount, viewOnly }) {
  const [items, setItems] = useState(null);
  const [del, setDel] = useState(null);
  useEffect(() => {
    api.get(mode === "review" ? "/show-notes/review" : "/show-notes/mine")
      .then(({ data }) => { setItems(data.items || []); onCount?.(data.pending_count || 0); }).catch(() => setItems([]));
  }, [mode, reload]); // eslint-disable-line react-hooks/exhaustive-deps

  const canDelete = (n) => !viewOnly && (mode === "review"
    ? n.status !== "published" && (n.status !== "draft" || n.author_id === userId)
    : ["pending", "returned"].includes(n.status));
  const remove = async () => {
    try { await api.delete(`/show-notes/${del.id}`); toast.success(mode === "review" ? "Notes deleted" : "Notes withdrawn"); onChanged(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setDel(null); }
  };

  if (!items) return <div className="flex justify-center py-16 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>;
  return (
    <>
      <NotesList items={items} onOpen={onOpen} onDelete={setDel} canDelete={canDelete} showStatus empty={COPY[mode]} testId={`notes-${mode}-list`} />
      <ConfirmDialog open={!!del} onOpenChange={(o) => !o && setDel(null)} destructive onConfirm={remove} testId="notes-delete-dialog"
        title={mode === "review" ? "Delete these notes?" : "Withdraw these notes?"}
        description={del ? `${noteTitle(del)} will be removed. This can't be undone.` : ""} confirmText={mode === "review" ? "Delete" : "Withdraw"} />
    </>
  );
}
